import { gql } from 'apollo-angular';

export var update_pricing_details = gql`
  mutation UPDATE_PRICING_DETAILS(
    $id: ID
    $project_id: ID
    $non_cra_execution: String
  ) {
    updatePricingDetails(
      id: $id
      project_id: $project_id
      non_cra_execution: $non_cra_execution
    ) {
      id
      non_cra_execution
    }
  }
`;
